import React from 'react'
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import { useState } from 'react'

import { LoginForm } from './LoginForm'
import { RecuperarForm } from './RecuperarForm';
import { useSelector } from 'react-redux';
import { RegisterForm } from './RegisterForm';
import { BodyTemplateRegister } from './nuevoRegister/BodyTemplateRegister';
import { BodyNuevaContrasenia } from './BodyNuevaContrasenia';

const body = document.getElementsByTagName('body')[0];

export const LoginScreen = () => {

    const {type} = useSelector(state => state.auth)

    // true  = LoginForm
    // false = RecuperarForm
    const [formView, setFormView] = useState(true);
    const [darkMode, setDarkMode] = useState((localStorage.getItem('theme') === 'dark'));
    
    const handleFormView= (e) =>{
        e.preventDefault();
        setFormView(!formView);
    }

    const handleDarkMode= (e) => {
        if(darkMode){
            localStorage.setItem('theme', 'light');
            body.classList.remove('dark-theme');
        } else{
            localStorage.setItem('theme', 'dark');
            body.classList.add('dark-theme');
        }
        setDarkMode(!darkMode);
    }

    return (
        <div className="auth-page sign-in">
            <div className="connect-container align-content-stretch d-flex flex-wrap">
                <div className="container-fluid">
                    <div className="row">
                        <div className={`${type === 'register' ? 'col-lg-8' : 'col-lg-8'}`}>
                            <div className="auth-form">
                                <div className="row">
                                    <div className="col">
                                        <div className="custom-control custom-switch mb-3">
                                            <input 
                                                type="checkbox" 
                                                className="custom-control-input" 
                                                id="customSwitch1" 
                                                checked={darkMode} 
                                                onChange={handleDarkMode} 
                                            />
                                            <label className="custom-control-label" htmlFor="customSwitch1"><i className="far fa-moon"></i> Dark mode</label>
                                        </div>
                                        <div className="logo-box">
                                            <img src={darkMode ? '/assets/images/logo-white.png': '/assets/images/logo-black.png'} alt="skyfet" />
                                        </div>
                                        <Router>
                                            <div>
                                                {/* A <Switch> looks through its children <Route>s and
                                                    renders the first one that matches the current URL. */}
                                                <Switch>
                                                    <Route path="/login/register/:id" exact component={BodyTemplateRegister} />
                                                    <Route path="/login/recuperar/:id" exact component={BodyNuevaContrasenia} />
                                                    <Route path="/">
                                                    {
                                                        formView 
                                                            ? (type === 'register') 
                                                                ? <RegisterForm />
                                                                : <LoginForm viewForm={handleFormView} /> 
                                                            : <RecuperarForm viewForm={handleFormView} />
                                                    }
                                                    </Route>
                                                </Switch>
                                            </div>
                                        </Router>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col d-none d-lg-block d-xl-block pr-0">
                            <div className="auth-image"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
